var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamingOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M10 12H8v2H6v-2H4v-2h2V8h2v2h2zm7 .5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm3-3a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm-3.031-4.352-4.5 2.532-.489.27-.492-.27-4.5-2.532L3 7.391v6.43l8.98 5.038 8.98-5.039V7.39L16.97 5.149m0-1.148 4.992 2.8v7.598L11.98 20 2 14.398V6.801L6.988 4l4.992 2.8zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingOutline);
export default __webpack_public_path__ + "static/media/gaming_outline.b0705a71b367a380823be4ea45b1efd9.svg";
export { ForwardRef as ReactComponent };